import { EoFormPanelConfig, EoFormControlConfig } from 'ngx-eo-web-components';
import { AbstractControl } from '@angular/forms';

export class FormPanelConfigBuilder {
  private fields: EoFormControlConfig[];

  constructor(
    private name: string,
    configs: EoFormControlConfig[],
    private options?: {
      header?: string;
      headerStyleClass?: string;
      styleClass?: string;
      panelStyleClass?: string;
    }
  ) {
    this.fields = [...configs];
  }

  public getControl(name: string): AbstractControl | undefined {
    const fb = this.fields.find(fb => fb.name === name);
    return fb?.control;
  }

  public add(config: EoFormControlConfig, index?: number): this {
    if (!this.fields.find(f => f.name === config.name)) {
      if (index !== undefined && index >= 0 && index <= this.fields.length) {
        this.fields.splice(index, 0, config);
      } else {
        this.fields.push(config);
      }
    }
    return this;
  }

  public remove(fieldName: string): this {
    this.fields = this.fields.filter(f => f.name !== fieldName);
    return this;
  }

  public updateFieldOptions(fieldName: string, options: any[]): this {
    const fb = this.fields.find(f => f.name === fieldName);
    if (fb && 'options' in fb) {
      (fb as any).options = options;
    }
    return this;
  }

  public build(): EoFormPanelConfig {
    return new EoFormPanelConfig({
      header: this.options?.header,
      headerStyleClass: this.options?.headerStyleClass,
      name: this.name,
      styleClass: this.options?.styleClass,
      panelContentStyleClass: this.options?.panelStyleClass ?? 'grid',
      config: this.fields.map(fb => fb),
    });
  }
}
